<template>
  <div>
    <div class="sm:flex items-start relative">
      <div class="w-24">
        <div
          class="bg-gray-200 text-sm px-2 leading-loose rounded inline-flex items-center"
          :class="{ 'bg-red-200 text-red-900': isInPast }"
          v-tooltip="`Reminder voor ${user.name_short}`"
        >
          <BaseIcon name="clock" size="16" />
          <div class="mx-1">{{ note.reminder_at | formatDay('D MMM.') }}</div>
        </div>
      </div>
      <div class="py-2 sm:py-0 sm:px-3 flex-1 text-gray-800">
        <NoteDescription :description="note.description" />
        <div
          class="mt-2 text-xs text-gray-500"
        >{{ note.created_at | formatTimeAgo | upperFirst }} toegevoegd door {{ createdBy.name_short }}</div>
      </div>
      <div class="absolute sm:static top-0 right-0">
        <BaseDropdown icon="more-vertical" button-class="btn-icon">
          <button type="button" class="dropdown-item" @click="done()">Afronden</button>
          <ModalButton class="dropdown-item w-40" label="Wijzigen">
            <NoteForm
              method="patch"
              :action="`/json/contacts/${contact.id}/notes/${note.id}`"
              :note="note"
              @success="setContact"
            />
          </ModalButton>
          <DeleteConfirmButton
            class="dropdown-item w-40"
            :message="`Weet je zeker dat je deze notitie wilt verwijderen?`"
            @confirm="deleteNote()"
          >Verwijderen</DeleteConfirmButton>
          <DeleteConfirmButton
            v-if="note.deal_id"
            class="dropdown-item w-40"
            :message="`Koppeling tussen deze notitie en deal verwijderen?`"
            confirm-text="Ja, ontkoppelen"
            @confirm="unlink()"
          >Deal ontkoppelen</DeleteConfirmButton>
        </BaseDropdown>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { post, destroy } from "@/api.js";
import NoteForm from "@/components/NoteForm";
import NoteDescription from "@/components/NoteDescription";
import DeleteConfirmButton from "@/components/DeleteConfirmButton";

export default {
  props: {
    note: {
      type: Object,
      required: true
    },
    contact: {
      type: Object,
      required: true
    }
  },

  components: {
    NoteForm,
    NoteDescription,
    DeleteConfirmButton
  },

  computed: {
    isInPast() {
      return dayjs(this.note.reminder_at).isBefore(dayjs(), "day");
    },

    user() {
      return this.note.reminder_for || {};
    },

    createdBy() {
      return this.note.created_by || {};
    }
  },

  methods: {
    done() {
      post(
        `/contacts/${this.contact.id}/notes/${this.note.id}/done`
      ).then(response => this.setContact(response.data));
    },

    unlink() {
      destroy(
        `/contacts/${this.contact.id}/notes/${this.note.id}/deal`
      ).then(response => this.setContact(response.data));
    },

    deleteNote() {
      destroy(
        `/contacts/${this.contact.id}/notes/${this.note.id}`
      ).then(response => this.setContact(response.data));
    },

    setContact(data) {
      this.$store.commit("SET_CONTACT", data);
    }
  }
};
</script>